import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
const CustomAccordion = styled(Accordion)(({ theme }) => ({
    border: `none`,
    borderRadius: '5px !important',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    '&::before':
    {
        display: 'none',
    },
    '& .MuiAccordionSummary-root':
    {
        borderBottom: '1px solid #E6E6E6',
        minHeight: '51px !important',

        '& .MuiAccordionSummary-content':
        {
            margin: '12px 0',
        },
        '& .MuiAccordionSummary-expandIconWrapper':
        {
            color:'#0D0145',
        }
    },
        '& .MuiAccordionDetails-root':
        {
            padding: '12px 16px',
        },
}));

export default CustomAccordion;